var _style, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeTenhaOsDadosDosClientesEDaSuaCorretoraAgger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0DadosClientes{fill:#005b87;}\r\n\t.st1DadosClientes{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st0DadosClientes",
    d: "M50,25c0,13.8-11.2,25-25,25S0,38.8,0,25S11.2,0,25,0S50,11.2,50,25"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st1DadosClientes",
    d: "M31.6,43H18.4c-1.8,0-3.3-1.5-3.3-3.3V10.3C15,8.4,16.5,7,18.4,7h13.3c1.8,0,3.3,1.5,3.3,3.3v29.4 C35,41.6,33.5,43,31.6,43z M16.5,36.2v3.5c0,1,0.8,1.8,1.8,1.8c0,0,0,0,0,0h13.3c1,0,1.8-0.8,1.8-1.8c0,0,0,0,0,0v-3.5H16.5z  M18.4,8.4c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v24.4h17V10.3c0-1-0.8-1.8-1.8-1.8c0,0,0,0,0,0H18.4z M25,40.2c-0.7,0-1.3-0.6-1.3-1.3 c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C26.3,39.6,25.7,40.2,25,40.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    className: "st1DadosClientes",
    d: "M22,17.9c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3c0,1.6-1.3,3-3,3c0,0,0,0,0,0C23.4,20.9,22,19.6,22,17.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    className: "st1DadosClientes",
    d: "M23.4,22.4h3.2c2.5-0.1,4.5,1.9,4.6,4.3H18.8C18.9,24.3,20.9,22.4,23.4,22.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTenhaOsDadosDosClientesEDaSuaCorretoraAgger);
export default __webpack_public_path__ + "static/media/icone-tenha-os-dados-dos-clientes-e-da-sua-corretora-agger.45277eef9abf1f190a91dce4a45cf886.svg";
export { ForwardRef as ReactComponent };